const SK_A = 'animate-pulse rounded-(--radius-md) bg-[var(--skeleton-base)]';

const SKEL_COLS = Array.from({ length: 7 });
const SKEL_ROWS = Array.from({ length: 5 });

/**
 * Full-page loading skeleton for the desktop agenda layout (toolbar, sidebar,
 * calendar grid) shown while events and calendars are loading.
 *
 * @returns The skeleton placeholder element.
 */
export function AgendaDesktopSkeleton() {
  return (
    <div className="flex min-h-0 flex-1 flex-col overflow-hidden rounded-[var(--radius-lg)] border border-[var(--border-subtle)] shadow-[var(--shadow-sm)]">
      <div className="shrink-0 border-b border-[var(--border-subtle)] bg-[var(--surface-primary)] px-(--space-5) py-(--space-3)">
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <div style={{ display: 'flex', gap: 'var(--space-2)', alignItems: 'center' }}>
            <div className={`${SK_A} h-8 w-8`} />
            <div className={`${SK_A} h-5 w-36`} />
            <div className={`${SK_A} h-8 w-8`} />
          </div>
          <div style={{ display: 'flex', gap: 'var(--space-2)' }}>
            <div className={`${SK_A} h-8 w-16`} />
            <div className={`${SK_A} h-8 w-20`} />
            <div className={`${SK_A} h-8 w-16`} />
          </div>
        </div>
      </div>
      <div className="flex min-h-0 flex-1">
        <div className="w-56 shrink-0 border-r border-[var(--border-subtle)] bg-[var(--surface-primary)] p-(--space-3)">
          <div className={`${SK_A} mb-(--space-3) h-9 w-full`} />
          <div className={`${SK_A} mb-(--space-2) h-4 w-24`} />
          <div className={`${SK_A} mb-(--space-2) h-4 w-32`} />
          <div className={`${SK_A} mb-(--space-4) h-4 w-28`} />
          <div className={`${SK_A} h-36 w-full`} />
        </div>
        <div className="flex min-h-0 min-w-0 flex-1 flex-col p-(--space-3)">
          <div className="flex min-h-0 flex-1 flex-col overflow-hidden rounded-(--radius-lg) border border-[var(--border-subtle)] bg-[var(--surface-primary)]">
            <div className="grid grid-cols-7 gap-px border-b border-[var(--border-subtle)] bg-[var(--border-ultra-subtle)]">
              {SKEL_COLS.map((_, i) => (
                <div key={i} className="flex justify-center bg-[var(--surface-primary)] py-(--space-2)">
                  <div className={`${SK_A} h-3 w-8`} />
                </div>
              ))}
            </div>
            <div className="grid flex-1 grid-cols-7 gap-px bg-[var(--border-ultra-subtle)]">
              {SKEL_ROWS.map((_, r) =>
                SKEL_COLS.map((_, c) => (
                  <div key={`${r}-${c}`} className="bg-[var(--surface-primary)] p-(--space-1-5)" />
                ))
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
